import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojalgaoncab() {



    const cardData = {

keyword: "Pune to Jalgaon Cab Service",

headingDescription:
    "Rising Cab Service offers safe, reliable, and affordable Pune to Jalgaon Cab Service for families, business travelers, students, and long-distance passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth and comfortable highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for work, education, or personal visits, Rising Cab Service ensures a hassle-free and comfortable journey to Jalgaon.",

topPlaces: [
    {
        title: "Ajanta Caves (Nearby UNESCO Site)",
        description:
            "Ajanta Caves near Jalgaon are a UNESCO World Heritage Site famous for ancient Buddhist rock-cut caves, murals, and sculptures that reflect India's rich cultural and artistic heritage."
    },
    {
        title: "Ellora Caves (Nearby Attraction)",
        description:
            "Ellora Caves are another UNESCO World Heritage Site located near Jalgaon, known for their rock-cut temples representing Hindu, Buddhist, and Jain traditions."
    },
    {
        title: "Mehrun Lake",
        description:
            "Mehrun Lake is a popular picnic spot in Jalgaon known for its peaceful environment, gardens, and evening views, making it a favorite local attraction."
    },
    {
        title: "Unapdev Hot Water Springs",
        description:
            "Unapdev is a natural hot water spring near Jalgaon believed to have medicinal properties, attracting tourists and spiritual visitors throughout the year."
    },
    {
        title: "Swinging Towers of Patna Devi (Nearby Region)",
        description:
            "The Patna Devi temple area near Jalgaon is known for its historic significance and scenic surroundings in the Satpura ranges."
    },
    {
        title: "Gandhi Research Foundation",
        description:
            "Gandhi Research Foundation in Jalgaon preserves Mahatma Gandhi’s teachings, documents, and exhibits, making it an important educational and cultural center."
    },
    {
        title: "Hatnur Dam",
        description:
            "Hatnur Dam on the Tapi River is a scenic reservoir near Jalgaon used for irrigation and is a peaceful spot for sightseeing and photography."
    },
    {
        title: "Yawal Wildlife Sanctuary",
        description:
            "Yawal Wildlife Sanctuary near Jalgaon is home to diverse flora and fauna, offering eco-tourism opportunities and nature exploration."
    },
    {
        title: "Padmalaya Temple",
        description:
            "Padmalaya Temple is a famous religious site dedicated to Lord Ganesha, attracting devotees from across Maharashtra."
    },
    {
        title: "Jalgaon Banana Belt",
        description:
            "Jalgaon is known as the 'Banana City of India' due to its large-scale banana farming and agricultural importance in the region."
    }
],



services: [
    {
        name: "Pune to Jalgaon Cab",
        description:
            "Rising Cab Service offers Pune to Jalgaon Cab for safe, comfortable, and reliable long-distance travel across Maharashtra. This service is ideal for family trips, business travel, student visits, and intercity journeys. We provide well-maintained AC vehicles including hatchbacks, sedans, SUVs, Innova, and Innova Crysta with experienced highway drivers ensuring smooth and timely travel. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. With transparent pricing, 24x7 availability, and professional support, we ensure a hassle-free journey between Pune and Jalgaon."
    },
    {
        name: "Pune to Jalgaon Taxi",
        description:
            "Book Pune to Jalgaon Taxi with Rising Cab Service for affordable, safe, and comfortable travel. Our taxis are suitable for solo passengers, families, and corporate travelers who need dependable intercity transportation with clean vehicles and experienced chauffeurs."
    },
    {
        name: "Cab from Pune to Jalgaon",
        description:
            "Rising Cab Service provides Cab from Pune to Jalgaon with flexible pickup options, AC vehicles, and professional drivers ensuring smooth highway travel and punctual service for all passengers."
    },
    {
        name: "Taxi from Pune to Jalgaon",
        description:
            "Our Taxi from Pune to Jalgaon service ensures safe, comfortable, and timely travel with experienced drivers, well-maintained vehicles, and budget-friendly pricing for all types of passengers."
    },
    {
        name: "Pune to Jalgaon Cab Service",
        description:
            "Rising Cab Service offers Pune to Jalgaon Cab Service with easy booking, reliable transportation, and professional drivers ensuring a smooth and stress-free journey."
    },
    {
        name: "Pune to Jalgaon Taxi Fare",
        description:
            "Get transparent Pune to Jalgaon Taxi Fare with no hidden charges. We offer competitive and affordable pricing suitable for one-way and round-trip long-distance travel."
    },
    {
        name: "Pune to Jalgaon One Way Cab",
        description:
            "Book Pune to Jalgaon One Way Cab for cost-effective single-trip travel with comfortable vehicles and professional drivers ensuring safe highway journeys."
    },
    {
        name: "Pune to Jalgaon Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Jalgaon Round Trip Taxi with flexible return timing, waiting options, and customized travel plans for families and business travelers."
    },
    {
        name: "Pune to Jalgaon Cab Booking",
        description:
            "Our Pune to Jalgaon Cab Booking service offers instant confirmation, multiple vehicle options, and 24x7 support for easy and quick travel planning."
    },
    {
        name: "Cheap Pune to Jalgaon Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Jalgaon Cab with budget-friendly fares while ensuring safety, comfort, and reliable service quality for all passengers."
    },
    {
        name: "Best Pune to Jalgaon Taxi",
        description:
            "Choose the Best Pune to Jalgaon Taxi with Rising Cab Service for premium comfort, punctual service, and experienced drivers ensuring smooth long-distance travel."
    },
    {
        name: "Sedan Pune to Jalgaon Cab",
        description:
            "Our Sedan Pune to Jalgaon Cab is ideal for individuals and small families seeking affordable and comfortable intercity travel with fuel-efficient vehicles."
    },
    {
        name: "SUV Pune to Jalgaon Taxi",
        description:
            "Book SUV Pune to Jalgaon Taxi for spacious seating, extra luggage capacity, and comfortable group travel on long highway routes."
    },
    {
        name: "Innova Pune to Jalgaon Cab",
        description:
            "Rising Cab Service offers Innova Pune to Jalgaon Cab for family and group travel with premium comfort, smooth rides, and reliable long-distance service."
    },
    {
        name: "Long Route Cab Pune Jalgaon",
        description:
            "Our Long Route Cab Pune Jalgaon service ensures safe, efficient, and comfortable highway travel with experienced drivers and well-planned routes for time-saving journeys."
    },
    {
        name: "Pune to Dhule Cab Service",
        description:
            "Rising Cab Service provides Pune to Dhule Cab Service with reliable intercity transportation, clean vehicles, and professional drivers for a smooth travel experience."
    },
    {
        name: "Pune to Dhule Cab",
        description:
            "Book Pune to Dhule Cab for safe, affordable, and comfortable travel suitable for families, solo travelers, and business trips."
    },
    {
        name: "Pune to Dhule Taxi",
        description:
            "Our Pune to Dhule Taxi service ensures timely pickup, smooth highway driving, and budget-friendly fares for all passengers."
    },
    {
        name: "Cab from Pune to Dhule",
        description:
            "Rising Cab Service offers Cab from Pune to Dhule with flexible booking options, AC vehicles, and experienced drivers for intercity travel."
    },
    {
        name: "Taxi from Pune to Dhule",
        description:
            "Our Taxi from Pune to Dhule service provides safe and comfortable travel with professional chauffeurs and clean, well-maintained vehicles."
    },
    {
        name: "Pune to Dhule Taxi Fare",
        description:
            "Get transparent Pune to Dhule Taxi Fare with affordable pricing and no hidden charges for one-way and round-trip journeys."
    },
    {
        name: "Pune to Dhule One Way Cab",
        description:
            "Book Pune to Dhule One Way Cab for economical single-trip travel with reliable service and comfortable vehicles."
    },
    {
        name: "Pune to Dhule Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Dhule Round Trip Taxi with flexible return options, waiting time, and customized travel plans."
    },
    {
        name: "Pune to Dhule Cab Booking",
        description:
            "Our Pune to Dhule Cab Booking service offers instant confirmation, multiple cab options, and 24x7 customer support for hassle-free travel."
    },
    {
        name: "Cheap Pune to Dhule Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Dhule Cab with budget-friendly fares while maintaining safety, comfort, and reliability."
    },
    {
        name: "Best Pune to Dhule Taxi",
        description:
            "Choose the Best Pune to Dhule Taxi for premium travel experience, punctual service, and professional drivers ensuring smooth journeys."
    },
    {
        name: "Sedan Pune to Dhule Cab",
        description:
            "Our Sedan Pune to Dhule Cab is perfect for individuals and small families looking for affordable and comfortable intercity travel."
    },
    {
        name: "SUV Pune to Dhule Taxi",
        description:
            "Book SUV Pune to Dhule Taxi for spacious seating, luggage capacity, and comfortable group travel on long-distance routes."
    },
    {
        name: "Innova Pune to Dhule Cab",
        description:
            "Rising Cab Service offers Innova Pune to Dhule Cab for family and group travel with premium comfort and reliable long-distance service."
    },
    {
        name: "Intercity Cab Pune Dhule",
        description:
            "Our Intercity Cab Pune Dhule service ensures safe, smooth, and efficient travel with professional drivers and well-maintained vehicles for long routes."
    }
],

tableData: [
    ["Pune to Jalgaon Cab", "Pune to Jalgaon Taxi"],
    ["Cab from Pune to Jalgaon", "Taxi from Pune to Jalgaon"],
    ["Pune to Jalgaon One Way Cab", "Pune to Jalgaon Round Trip Taxi"],
    ["Pune to Jalgaon Cab Service", "Pune to Jalgaon Taxi Fare"],
    ["Cheap Pune to Jalgaon Cab", "Best Pune to Jalgaon Taxi"],
    ["Sedan Pune to Jalgaon Cab", "SUV Pune to Jalgaon Taxi"],
    ["Innova Pune to Jalgaon Cab", "Long Route Cab Pune Jalgaon"],
    ["Pune to Jalgaon Cab Booking", "Pune to Dhule Cab Service"],
    ["Pune to Dhule Cab", "Pune to Dhule Taxi"],
    ["Pune to Dhule One Way Cab", "Pune to Dhule Round Trip Taxi"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Jalgaon Cab Service",
        WhyChoosedescription: "Rising Cab Service offers reliable Pune to Jalgaon cab transportation for families, business travelers, tourists, students, and passengers seeking hassle-free long-distance travel."
    },
    {
        WhyChooseheading: "Ideal for Business, Personal, and Family Trips",
        WhyChoosedescription: "Whether you're traveling for official meetings, family functions, educational purposes, social visits, or personal work, we provide suitable travel solutions."
    },
    {
        WhyChooseheading: "Travel with Modern and Spacious Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count and comfort requirements."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Options",
        WhyChoosedescription: "Customers can select one-way journeys, return trips, multi-day travel packages, or customized itineraries according to their schedule."
    },
    {
        WhyChooseheading: "Convenient for North Maharashtra Travel",
        WhyChoosedescription: "Our Pune to Jalgaon cab service is a preferred choice for travelers visiting Jalgaon and nearby destinations across North Maharashtra."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune Region",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, Pune Airport, and nearby areas."
    },
    {
        WhyChooseheading: "Safe Long-Distance Travel Experience",
        WhyChoosedescription: "Experienced drivers and well-maintained vehicles ensure smooth highway travel and a comfortable journey throughout the route."
    },
    {
        WhyChooseheading: "Customized Travel Planning Available",
        WhyChoosedescription: "Passengers can include sightseeing stops, business visits, family destinations, and nearby attractions as part of their travel itinerary."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Jalgaon from Pune?",
        answer: "Jalgaon is known for its educational institutions, business activities, agricultural sector, family connections, and proximity to popular tourist destinations."
    },
    {
        question: "Can customers book a one-way cab from Pune to Jalgaon?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle category is commonly chosen for this route?",
        answer: "Ertiga, Innova Crysta, SUVs, and Sedan cars are frequently selected for comfort during long-distance travel."
    },
    {
        question: "Is same-day return travel available for Jalgaon trips?",
        answer: "Yes, same-day return options can be arranged depending on travel plans and customer requirements."
    },
    {
        question: "Can business travelers use Pune to Jalgaon cab services?",
        answer: "Yes, many professionals utilize this service for meetings, industrial visits, site inspections, and corporate travel."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, educational tours, and corporate teams."
    },
    {
        question: "Can nearby attractions be added to the itinerary?",
        answer: "Yes, customized travel plans can include sightseeing locations, temples, historical sites, and nearby destinations."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, customers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking recommended for long-distance routes?",
        answer: "Yes, advance reservations help ensure preferred vehicle availability and better travel planning."
    },
    {
        question: "How can I book a Pune to Jalgaon Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Yogesh Patil",
        feedback:
            "Traveling to Jalgaon for a family gathering was extremely convenient with Rising Cab Service. The vehicle was comfortable, and the journey remained smooth throughout the route.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priti Mahajan",
        feedback:
            "We planned a long-distance trip from Pune to Jalgaon and received excellent service. The driver was professional, the cab was well-maintained, and the overall experience was highly satisfying.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Jalgaon Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-jalgaon-cab.jpg",
"description": "Book Pune to Jalgaon Cab Service with Rising Cab Service for safe, comfortable, and affordable long-distance travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova options for family and business trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-jalgaon-cab-service"
}
};






    return (
        <div>
<Helmet>
  <title>Pune to Jalgaon Cab Service | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Jalgaon Cab Service for safe and affordable long-distance travel. Get reliable one-way and round-trip taxi service with sedan, SUV, and Innova cars at best prices."
/>

<meta
 name="keywords"
 content="pune to jalgaon cab, pune to jalgaon taxi, cab from pune to jalgaon, taxi from pune to jalgaon, pune to jalgaon cab service, pune to jalgaon taxi fare, pune to jalgaon one way cab, pune to jalgaon round trip taxi, pune to jalgaon cab booking, cheap pune to jalgaon cab, best pune to jalgaon taxi, sedan pune to jalgaon cab, suv pune to jalgaon taxi, innova pune to jalgaon cab, long route cab pune jalgaon, Pune to Dhule Cab Service, Pune to dhule cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetojalgaoncab;